import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatEUR, formatDate } from "@/lib/constants";

// Ratenauswahl für „Ratenzahlung“: lädt aktiven Plan + vorgeschlagene Rate.
export function RateSelect({ tenancyId, value, onChange, testId = "rate-select" }) {
  const [sug, setSug] = useState(null);
  useEffect(() => {
    api.get(`/rent-installments/${tenancyId}/suggestion`).then(({ data }) => {
      setSug(data);
      if (data.plan_id && !value?.plan_id) onChange({ plan_id: data.plan_id, index: data.suggested_index });
    }).catch(() => setSug({ plan_id: null, installments: [] }));
  }, [tenancyId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!sug) return <div className="text-xs text-slate-500">Ratenplan wird geladen…</div>;
  if (!sug.plan_id) return <div className="text-xs text-rose-700" data-testid={`${testId}-none`}>Kein aktiver Ratenplan für dieses Mietverhältnis.</div>;
  return (
    <div className="space-y-1">
      <div className="text-[11px] text-slate-600">Auf Rate buchen (Vorschlag: nächste offene Rate)</div>
      <select value={value?.index || ""} onChange={(e) => onChange({ plan_id: sug.plan_id, index: Number(e.target.value) })}
              className="w-full h-9 border border-slate-300 rounded-md px-2 text-sm" data-testid={testId}>
        {sug.installments.map((i) => (
          <option key={i.index} value={i.index}>
            Rate {i.index} · fällig {formatDate(i.due_date)} · {formatEUR(i.amount_eur)}
            {i.paid_amount_eur > 0 ? ` (bezahlt ${formatEUR(i.paid_amount_eur)})` : ""}
            {i.index === sug.suggested_index ? " — Vorschlag" : ""}
          </option>
        ))}
      </select>
      <div className="text-[11px] text-slate-500">Der Betrag tilgt die Rückstände des Plans: älteste zuerst, je Monat Kaltmiete vor NK.</div>
    </div>
  );
}
